import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core'

import { AuthService } from '@app/core/service/auth.service'
import { EnvService } from '@envs/env-service'
import { Router } from '@angular/router'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'notification-profiles',
  templateUrl: './notification-profiles.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationProfilesComponent implements OnInit {
  baseJsUrl: string

  constructor(
    private envService: EnvService,
    private authService: AuthService,
    private titleService: Title,
    private router: Router
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Notification Profiles | Admin | Scope')
    this.baseJsUrl = `${this.envService.baseJsUrl}/admin/notification/profiles?tab=application&childCompany=${this.authService.loggedInUser?.company.id}`
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data.action === 'adminNavigate')
      this.router.navigate([`/manage`], { queryParams: { tab: 'application' } })
  }
}
